import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { getCompanyManagementModuleName } from './company-management.permissions';

export class CompaniesPermissions {
  static GroupName = `${getCompanyManagementModuleName()}`;

  static getPermissions = getGroupPermissionFactory(CompaniesPermissions.GroupName);

  static Permissions = {
    Create: CompaniesPermissions.getPermissions(PermissionEnum.CREATE),
    Read: CompaniesPermissions.getPermissions(PermissionEnum.READ),
    ReadAll: CompaniesPermissions.getPermissions(PermissionEnum.READ_ALL),
    Update: CompaniesPermissions.getPermissions(PermissionEnum.UPDATE),
  };
}